"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var core_1 = require("./core");
var mobx_1 = require("mobx");
var arrayItemIdKey = "<id>";
function getArrayItemId(item, idKey) {
    return item && typeof item === "object" && item[idKey || arrayItemIdKey];
}
exports.getArrayItemId = getArrayItemId;
function setArrayItemId(item, id, idKey) {
    if (item && typeof item === "object") {
        item[idKey || arrayItemIdKey] = id;
    }
}
function setArrayItemIds(ar, idKey) {
    var nextId = 1;
    var usedIds = {};
    // First pass - clear IDs that are duplicates
    for (var _i = 0, ar_1 = ar; _i < ar_1.length; _i++) {
        var item = ar_1[_i];
        var id = getArrayItemId(item, idKey);
        if (id !== undefined) {
            nextId = typeof id === "number" ? Math.max(nextId, id + 1) : nextId;
            if (usedIds[id]) {
                setArrayItemId(item, undefined, idKey);
            }
            else {
                usedIds[id] = true;
            }
        }
    }
    // Second pass - allocate IDs
    for (var _a = 0, ar_2 = ar; _a < ar_2.length; _a++) {
        var item = ar_2[_a];
        var id = getArrayItemId(item, idKey);
        if (id === undefined) {
            setArrayItemId(item, nextId++, idKey);
        }
    }
}
function saveItemWithId(item) {
    return __assign({}, core_1.save(item), (_a = {}, _a[arrayItemIdKey] = getArrayItemId(item), _a));
    var _a;
}
function getArrayJsonComputed(ar, itemFactory, idKey) {
    return core_1.getOrCreateComputed(ar, "<json>", function () { return ({
        get: function () {
            setArrayItemIds(ar, idKey);
            return ar.map(idKey ? core_1.save : saveItemWithId);
        },
        set: function (data) {
            if (!core_1.isArray(data)) {
                ar.length = 0; // most likely schema has changed
                return;
            }
            // Build map of existing items by ID
            var existing = {};
            for (var _i = 0, ar_3 = ar; _i < ar_3.length; _i++) {
                var item = ar_3[_i];
                var id = getArrayItemId(item, idKey);
                if (id !== undefined && !existing[id]) {
                    existing[id] = item;
                }
            }
            // Bring into line with supplied data
            ar.length = data.length;
            for (var i = 0; i < data.length; i++) {
                var itemJson = data[i];
                var itemId = getArrayItemId(itemJson, idKey);
                // Reuse existing item with same id
                var item = existing[itemId];
                if (item) {
                    delete existing[itemId];
                }
                else {
                    item = itemFactory();
                    setArrayItemId(item, itemId, idKey);
                }
                core_1.load(item, itemJson);
                ar[i] = item;
            }
            // Dispose any items not reused
            for (var _a = 0, _b = Object.keys(existing); _a < _b.length; _a++) {
                var key = _b[_a];
                var item = existing[key];
                if (item.dispose) {
                    item.dispose();
                }
            }
        }
    }); });
}
function array(factory, id) {
    var result = mobx_1.observable([]);
    Object.defineProperty(result, "json", {
        get: function () {
            return getArrayJsonComputed(this, factory, id).get();
        },
        set: function (data) {
            getArrayJsonComputed(this, factory, id).set(data);
        }
    });
    return result;
}
exports.array = array;
function arrayOf(ctor, id) {
    return array(function () { return new ctor(); }, id);
}
exports.arrayOf = arrayOf;
//# sourceMappingURL=array.js.map